/* Motique — redesign 2026. Comportamenti delle sezioni mq-*. Niente librerie. */
(function () {
  'use strict';
  var S = window.mqStrings || {};
  // Le traduzioni arrivano con le entita' HTML (&#39;): si decodificano una volta.
  var dec = document.createElement('textarea');
  Object.keys(S).forEach(function (k) { dec.innerHTML = S[k]; S[k] = dec.value; });
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  // Stesso formato di Liquid (shop.money_format), non quello del browser: il prezzo non cambia aspetto al cambio colore.
  function money(cents) {
    // il formato del negozio contiene <span class=trans-money> (app valute): si tolgono i tag
    var f = (S.moneyFormat || '€{{amount_with_comma_separator}}').replace(/<[^>]*>/g, ''), v = cents / 100;
    var fmt = function (dec, th, ds) { var p = v.toFixed(dec).split('.'); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th); return p.join(ds); };
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_with_comma_separator') return fmt(2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return fmt(0, '.', ',');
      if (k === 'amount_no_decimals') return fmt(0, ',', '.');
      if (k === 'amount_with_apostrophe_separator') return fmt(2, "'", '.');
      return fmt(2, ',', '.');
    });
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  /* ---------- Dialoghi (menu, filtri, aggiunto al carrello) ---------- */
  var lastOpener = null;
  function openDialog(id, opener) {
    var d = document.getElementById(id);
    if (!d || typeof d.showModal !== 'function') return null;
    lastOpener = opener || document.activeElement;
    if (!d.open) d.showModal();
    document.documentElement.style.overflow = 'hidden';
    return d;
  }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-mq-open]');
    if (o) { e.preventDefault(); openDialog(o.getAttribute('data-mq-open'), o); return; }
    var c = e.target.closest('[data-mq-close]');
    if (c) { var d = c.closest('dialog'); if (d) d.close(); return; }
    if (e.target.tagName === 'DIALOG' && e.target.classList.contains('mq-drawer')) e.target.close();
  });
  document.addEventListener('close', function (e) {
    if (e.target.tagName !== 'DIALOG') return;
    document.documentElement.style.overflow = '';
    // il cassetto del carrello torna allo stato di partenza, quello dell'icona («Il tuo carrello», niente «Appena aggiunto»)
    if (e.target.id === 'mq-added') { e.target.removeAttribute('data-state'); $$('.mq-cd__just', e.target).forEach(function (j) { j.hidden = true; }); }
    if (lastOpener && lastOpener.focus) lastOpener.focus();
  }, true);

  /* ---------- Header: filetto quando si scorre ---------- */
  var header = $('.mq-header');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-stuck', window.scrollY > 4); };
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
  }

  /* ---------- Menu a tendina «Veicoli» ---------- */
  $$('[data-mq-navdrop]').forEach(function (d) {
    var btn = $('button', d), panel = $('.mq-navdrop__panel', d), timer, byHover = false;
    var set = function (open) { btn.setAttribute('aria-expanded', String(open)); panel.hidden = !open; if (!open) byHover = false; };
    // il primo clic dopo l'apertura col mouse la lascia aperta (collaudo 30/10, D4); con la tastiera il clic inverte
    btn.addEventListener('click', function () { if (byHover) { byHover = false; return; } set(btn.getAttribute('aria-expanded') !== 'true'); });
    if (window.matchMedia('(hover: hover)').matches) {
      d.addEventListener('mouseenter', function () { clearTimeout(timer); byHover = btn.getAttribute('aria-expanded') !== 'true'; set(true); });
      d.addEventListener('mouseleave', function () { timer = setTimeout(function () { set(false); }, 150); });
    }
    d.addEventListener('keydown', function (e) { if (e.key === 'Escape') { set(false); btn.focus(); } });
    document.addEventListener('click', function (e) { if (!d.contains(e.target)) set(false); });
    d.addEventListener('focusout', function (e) { if (!d.contains(e.relatedTarget)) set(false); });
  });

  /* ---------- Caroselli con frecce ---------- */
  $$('[data-mq-rail]').forEach(function (rail) {
    var id = rail.id, prev = $('[data-mq-rail-prev="' + id + '"]'), next = $('[data-mq-rail-next="' + id + '"]');
    if (!prev || !next) return;
    var step = function () { var c = rail.firstElementChild; return c ? c.getBoundingClientRect().width + 24 : rail.clientWidth; };
    var sync = function () {
      prev.disabled = rail.scrollLeft < 4;
      next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 4;
    };
    prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: reduce ? 'auto' : 'smooth' }); });
    next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: reduce ? 'auto' : 'smooth' }); });
    rail.addEventListener('scroll', sync, { passive: true }); window.addEventListener('resize', sync); sync();
  });

  /* ---------- Video: parte solo in vista, muto; pausa sempre visibile ---------- */
  function wireVideo(video, btn) {
    if (!video) return;
    var userPaused = false;
    var setBtn = function () {
      if (!btn) return;
      var playing = !video.paused;
      btn.setAttribute('aria-label', playing ? S.pause : S.play);
      btn.setAttribute('aria-pressed', playing ? 'false' : 'true');
      var lbl = btn.querySelector('[data-label]');
      if (lbl) lbl.textContent = playing ? S.pauseVideo : S.playVideo;
      btn.querySelectorAll('[data-state]').forEach(function (n) { n.hidden = n.getAttribute('data-state') !== (playing ? 'playing' : 'paused'); });
    };
    video.addEventListener('play', function () { if (video.offsetWidth) setBtn(); }); video.addEventListener('pause', function () { if (video.offsetWidth) setBtn(); });
    if (btn) btn.addEventListener('click', function () {
      if (!video.offsetWidth) return; // lo stesso pulsante serve ai due video dell'apertura: comanda solo quello che si vede
      if (video.paused) { userPaused = false; video.play(); } else { userPaused = true; video.pause(); }
    });
    video.addEventListener('play', function () { if (!video.offsetWidth) video.pause(); });
    if (reduce) { video.removeAttribute('autoplay'); video.pause(); setBtn(); return; }
    new IntersectionObserver(function (en) {
      en.forEach(function (x) {
        if (x.isIntersecting && !userPaused) { if (video.preload === 'none') video.preload = 'metadata'; var p = video.play(); if (p && p.catch) p.catch(function () {}); }
        else if (!x.isIntersecting) video.pause();
      });
    }, { threshold: 0.4 }).observe(video);
    if (video.offsetWidth) setBtn();
  }
  // Apertura con due video (computer 16:9, telefono 9:16): si collegano tutti e due, ma parte e si scarica solo quello
  // che si vede, perché il video nascosto (display: none) non risulta mai «in vista» all'IntersectionObserver.
  // Prima si sceglieva con getComputedStyle all'avvio: con mq-home.css caricato dopo, sceglieva male e l'apertura restava ferma (31/10).
  $$('[data-mq-video]').forEach(function (v) { wireVideo(v, $('[data-mq-video-toggle~="' + v.id + '"]')); });

  /* ---------- Galleria scheda ---------- */
  $$('[data-mq-gallery]').forEach(function (g) {
    var track = $('[data-mq-track]', g), slides = $$('.mq-gallery__slide', track);
    var marks = $$('[data-mq-goto]', g), count = $('[data-mq-count]', g);
    var go = function (i, instant) { track.scrollTo({ left: slides[i].offsetLeft - slides[0].offsetLeft, behavior: (reduce || instant) ? 'auto' : 'smooth' }); };
    var current = function () { return Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); };
    var mark = function () { var i = current(); if (count) count.textContent = (i + 1) + ' / ' + slides.length; marks.forEach(function (m) { var on = +m.getAttribute('data-mq-goto') === i; m.setAttribute('aria-current', String(on)); if (on && m.parentElement.classList.contains('mq-gallery__thumbs')) m.parentElement.scrollTo({ left: m.offsetLeft - m.parentElement.offsetLeft - 12, behavior: 'auto' }); }); };
    marks.forEach(function (m) { m.addEventListener('click', function () { go(+m.getAttribute('data-mq-goto')); }); });
    var raf; track.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(mark); }, { passive: true });
    g.mqGoToMedia = function (mediaId, instant) {
      var i = slides.findIndex(function (s) { return s.getAttribute('data-media-id') === String(mediaId); });
      if (i >= 0) go(i, instant);
    };
    mark();
  });

  /* ---------- Scheda: varianti, prezzo, barra fissa ---------- */
  $$('[data-mq-product]').forEach(function (root) {
    var dataEl = $('script[data-mq-product-json]', root);
    if (!dataEl) return;
    var data = JSON.parse(dataEl.textContent);
    var form = $('form[data-mq-add]', root), idInput = form && form.querySelector('input[name="id"]');
    var selected = (data.variants.find(function (v) { return v.id === data.current; }) || data.variants[0]).options.slice();
    var gallery = $('[data-mq-gallery]');
    var find = function () { return data.variants.find(function (v) { return v.options.every(function (o, i) { return o === selected[i]; }); }); };

    function render(v) {
      $$('[data-mq-opt-value]', root).forEach(function (n) { n.textContent = selected[+n.getAttribute('data-mq-opt-value')]; });
      $$('[data-mq-option]', root).forEach(function (b) {
        var pos = +b.getAttribute('data-pos'), val = b.getAttribute('data-value');
        b.classList.toggle('is-active', selected[pos] === val);
        b.setAttribute('aria-pressed', String(selected[pos] === val));
        var ok = data.variants.some(function (x) { return x.available && x.options[pos] === val && x.options.every(function (o, i) { return i === pos || o === selected[i]; }); });
        b.classList.toggle('is-soldout', !ok);
        var st = b.querySelector('[data-mq-vstock]'); if (st) st.textContent = ok ? S.available_cap : S.soldOutCap;
      });
      var add = $('[data-mq-add-btn]', root), stock = $('[data-mq-stock]', root);
      var priceEls = $$('[data-mq-price]'), stickyVar = $('[data-mq-sticky-variant]');
      if (!v) {
        if (idInput) idInput.value = '';
        if (add) { add.disabled = true; add.querySelector('[data-label]').textContent = S.unavailable; }
        if (stock) { stock.textContent = S.unavailable; stock.className = 'mq-buy__stock mq-stock'; }
        return;
      }
      if (idInput) idInput.value = v.id;
      if (form) form.setAttribute('data-mq-max', v.max == null ? '' : v.max);
      var priceHtml = money(v.price) + (v.compare_at_price > v.price ? ' <s>' + money(v.compare_at_price) + '</s>' : '');
      var saveHtml = v.compare_at_price > v.price ? '<span class="mq-price__save">−' + Math.round((1 - v.price / v.compare_at_price) * 100) + '%</span>' : '';
      priceEls.forEach(function (p) { p.innerHTML = priceHtml + (p.hasAttribute('data-mq-save') ? saveHtml : ''); });
      $$('[data-mq-price-plain]').forEach(function (p) { p.textContent = money(v.price); });
      $$('[data-mq-free]', root).forEach(function (f) { f.hidden = v.price < +f.getAttribute('data-mq-free'); });
      $$('[data-mq-klarna]', root).forEach(function (k) { k.setAttribute('data-purchase-amount', v.price); });
      $$('[data-mq-signup-final]', root).forEach(function (n) { n.textContent = money(v.price - Math.round(v.price / 10)); });
      if (add) {
        add.disabled = !v.available;
        add.querySelector('[data-label]').textContent = v.available ? S.addToCart + ' · ' + money(v.price) : S.soldOut;
      }
      $$('[data-mq-deliv]').forEach(function (n) { n.hidden = !v.available; });
      $$('[data-mq-sticky-btn]').forEach(function (b) { b.disabled = !v.available; b.textContent = v.available ? S.addToCart : S.soldOut; });
      if (stock) {
        var name = v.options[0];
        stock.textContent = data.single ? (v.available ? S.available_cap : S.soldOutCap) : (name + ' ' + (v.available ? S.available : S.soldOutLower));
        stock.className = 'mq-buy__stock mq-stock' + (v.available ? ' mq-stock--ok' : '');
      }
      if (stickyVar) stickyVar.textContent = v.title;
      if (history.replaceState) { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(history.state, '', u); }
    }
    $$('[data-mq-option]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        selected[+b.getAttribute('data-pos')] = b.getAttribute('data-value');
        var v = find(); render(v);
        // una pagina per colore: con le foto per colore la galleria la fa il server (mq-main-product.liquid)
        if (v && data.pages && v.id !== data.current) { location.assign(location.href); return; }
        if (v && v.media && gallery && gallery.mqGoToMedia) gallery.mqGoToMedia(v.media);
      });
    });
    var first = find(); render(first);
    // all'apertura la foto e' quella del colore scelto (difetto noto del live, sections/rd-main-product.liquid)
    if (first && first.media && gallery && gallery.mqGoToMedia) requestAnimationFrame(function () { gallery.mqGoToMedia(first.media, true); });

    var sticky = $('[data-mq-sticky]'), mainBtn = $('[data-mq-add-btn]', root);
    if (sticky && mainBtn && 'IntersectionObserver' in window) {
      sticky.hidden = false;
      // Racconto (tavola scheda-racconto, 01/11): la barra c'è anche all'arrivo, se il pulsante della scheda è sotto la prima schermata,
      // e sparisce solo mentre il pulsante è in vista. Nascosta è anche inert: niente tab su pulsanti che non si vedono.
      new IntersectionObserver(function (en) {
        var gone = !en[0].isIntersecting;
        sticky.classList.toggle('is-visible', gone);
        sticky.setAttribute('aria-hidden', String(!gone));
        sticky.inert = !gone;
        document.body.classList.toggle('rd-has-sticky-buy', gone); // alza il bollino WhatsApp (.mq-wa, snippets/mq-wa.liquid)
      }).observe(mainBtn);
      $('[data-mq-sticky-btn]', sticky).addEventListener('click', function () { form.requestSubmit ? form.requestSubmit() : form.submit(); });
      var back = $('[data-mq-sticky-variant-btn]', sticky);
      if (back) back.addEventListener('click', function () {
        var opts = $('[data-mq-options]', root) || root;
        opts.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
      });
    }
  });

  /* ---------- Aggiunta al carrello (scheda e card) ---------- */
  function updateCount(n) {
    $$('[data-mq-cart-count]').forEach(function (el) { el.textContent = n; if (n > 0) el.removeAttribute('data-empty'); else el.setAttribute('data-empty', ''); });
  }
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-mq-add]');
    if (!form || !window.fetch) return;
    e.preventDefault();
    mqNoPopup = true; // chi sta comprando non si interrompe con il popup −10% (vedi «Una finestra alla volta»)
    var btns = $$('button[type="submit"], [data-mq-sticky-btn]').filter(function (b) { return form.contains(b) || b.hasAttribute('data-mq-sticky-btn'); });
    btns.forEach(function (b) { b.classList.add('is-loading'); b.setAttribute('aria-busy', 'true'); });
    var err = $('[data-mq-add-error]', form);
    if (err) err.hidden = true;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    // Shopify accetta pezzi oltre la giacenza e li toglie solo al checkout (collaudo 30/10, D3): ci si ferma qui
    var max = form.getAttribute('data-mq-max');
    (max ? fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var id = +form.elements.id.value, q = +(form.elements.quantity && form.elements.quantity.value) || 1;
      var has = cart.items.reduce(function (n, i) { return n + (i.variant_id === id ? i.quantity : 0); }, 0);
      if (has + q > +max) throw { description: S.quantityError.replace('[quantity]', max) };
    }) : Promise.resolve())
      .then(function () {
        var body = new FormData(form);
        body.append('sections', 'mq-cart-drawer'); // il cassetto torna già con tutte le righe (Section Rendering API)
        body.append('sections_url', location.pathname);
        return fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: body });
      })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (item) { return fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) { showAdded(item, cart); }); })
      .catch(function (j) {
        if (err) { err.textContent = (j && (j.description || j.message)) || S.addError; err.hidden = false; err.scrollIntoView({ block: 'center', behavior: reduce ? 'auto' : 'smooth' }); }
        else alert((j && (j.description || j.message)) || S.addError);
      })
      .then(function () { btns.forEach(function (b) { b.classList.remove('is-loading'); b.removeAttribute('aria-busy'); }); });
  });
  // Cassetto del carrello (sections/mq-cart-drawer.liquid): si sostituisce solo il pannello, mai il <dialog> aperto (si chiuderebbe).
  // Il riquadro del secondo veicolo dipende dal prodotto della pagina: se la risposta non ce l'ha, resta quello di prima.
  function swapDrawer(html) {
    var d = document.getElementById('mq-added');
    if (!d || !html) return;
    var fresh = $('[data-mq-cd-panel]', new DOMParser().parseFromString(html, 'text/html')), old = $('[data-mq-cd-panel]', d);
    if (!fresh || !old) return;
    var second = $('.mq-cd__second', old), lines = $('.mq-cd__lines', fresh);
    if (second && lines && !$('.mq-cd__second', fresh)) lines.after(second);
    old.replaceWith(fresh);
  }
  function say(text) { var st = $('[data-mq-cd-status]'); if (st) { st.textContent = ''; setTimeout(function () { st.textContent = text; }, 50); } }
  function showAdded(item, cart) {
    updateCount(cart.item_count);
    var d = document.getElementById('mq-added');
    if (!d) { location.href = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart'; return; }
    swapDrawer(item.sections && item.sections['mq-cart-drawer']);
    d.setAttribute('data-state', 'added');
    $$('.mq-cd__line', d).forEach(function (li) { $('.mq-cd__just', li).hidden = li.getAttribute('data-key') !== item.key; });
    say(S.justAdded + ': ' + String(item.product_title).split(' · ')[0]);
    openDialog('mq-added');
    var focus = $('[data-mq-added-focus]', d); if (focus) focus.focus();
  }
  // Tornando indietro il browser rimostra la pagina com'era (bfcache): cassetto e numero sull'icona si rileggono dal carrello vero
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted || !document.getElementById('mq-added') || !window.fetch) return;
    fetch(location.pathname + '?sections=mq-cart-drawer').then(function (r) { return r.json(); }).then(function (j) {
      swapDrawer(j['mq-cart-drawer']);
      var p = $('#mq-added [data-mq-cd-panel]'); if (p) updateCount(+p.getAttribute('data-count'));
    }).catch(function () {});
  });
  // «Rimuovi» e «Togli uno» nel cassetto: cart/change.js con la chiave della riga (gli indici cambiano dopo una rimozione).
  // Senza JS i link portano a /cart/change, come nella pagina carrello.
  document.addEventListener('click', function (e) {
    var a = e.target.closest('#mq-added [data-mq-cd-qty]');
    if (!a || !window.fetch) return;
    e.preventDefault();
    var d = document.getElementById('mq-added'), li = a.closest('.mq-cd__line'), key = li.getAttribute('data-key');
    var idx = $$('.mq-cd__line', d).indexOf(li), just = $$('.mq-cd__line', d).filter(function (l) { return !$('.mq-cd__just', l).hidden; }).map(function (l) { return l.getAttribute('data-key'); })[0];
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    a.setAttribute('aria-busy', 'true');
    fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: +a.getAttribute('data-mq-cd-qty'), sections: 'mq-cart-drawer', sections_url: location.pathname }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (cart) {
        updateCount(cart.item_count);
        swapDrawer(cart.sections && cart.sections['mq-cart-drawer']);
        $$('.mq-cd__line', d).forEach(function (l) { $('.mq-cd__just', l).hidden = l.getAttribute('data-key') !== just; });
        say(cart.item_count ? (cart.item_count === 1 ? S.oneItem : S.items.replace('{n}', cart.item_count)) : S.emptyTitle);
        // il link toccato non c'è più: il fuoco va sulla stessa riga (o sull'ultima), altrimenti sul titolo
        var rows = $$('.mq-cd__line', d), row = rows[Math.min(idx, rows.length - 1)];
        var next = (row && $('[data-mq-cd-qty="0"]', row)) || $('#mq-added-title', d);
        if (next) next.focus();
      })
      .catch(function (j) { a.removeAttribute('aria-busy'); alert((j && (j.description || j.message)) || S.addError); });
  });

  /* ---------- Collezione: i filtri si applicano al cambio ---------- */
  $$('form[data-mq-autosubmit]').forEach(function (f) {
    var send = function () { f.requestSubmit ? f.requestSubmit() : f.submit(); };
    f.addEventListener('change', function (e) {
      if (e.target.matches('input[type="number"]')) return;
      send();
    });
    // il prezzo (modulo senza bottone) parte con Invio o uscendo dal campo cambiato, non a ogni freccia (collaudo 30/10, D1)
    f.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target.matches('input[type="number"]')) { e.preventDefault(); send(); }
    });
    f.addEventListener('focusout', function (e) {
      if (e.target.matches('input[type="number"]') && e.target.value !== e.target.defaultValue) send();
    });
  });
  $$('form[data-mq-filters]').forEach(function (f) {
    f.addEventListener('submit', function () {
      // i campi vuoti non sporcano l'indirizzo
      $$('input', f).forEach(function (i) { if (!i.value && i.type !== 'checkbox') i.disabled = true; });
    });
  });

  /* ---------- Finder nella home ---------- */
  $$('[data-mq-finder]').forEach(function (box) {
    var data = JSON.parse($('script[data-mq-finder-json]', box).textContent);
    var form = $('form', box), steps = $$('[data-step]', form), bars = $$('.mq-finder__progress span', box);
    var label = $('[data-mq-step-label]', box), err = $('[data-mq-finder-error]', box), out = $('[data-mq-finder-out]', box);
    var at = 0;
    function show(i) {
      at = i;
      var last = steps.length - 1;
      steps.forEach(function (s, k) { s.hidden = k !== i; });
      bars.forEach(function (b, k) { b.classList.toggle('is-on', k <= i); });
      if (label) { label.hidden = i === last; label.textContent = S.step.replace('{n}', i + 1).replace('{t}', last); }
      // un bottone può avere tutti e due i limiti («Indietro» non c'è nei risultati, dove c'è «Modifica le risposte»)
      $$('[data-mq-show-from], [data-mq-show-until]', form).forEach(function (b) {
        var f = b.getAttribute('data-mq-show-from'), u = b.getAttribute('data-mq-show-until');
        b.hidden = (f !== null && i < +f) || (u !== null && i > +u);
      });
      if (i < last) $('[data-mq-finder-all]', form).hidden = true;
      err.hidden = true;
      if (i > 0) { var f = steps[i].querySelector('legend, [tabindex="-1"]'); if (f) { f.setAttribute('tabindex', '-1'); f.focus({ preventScroll: true }); } }
    }
    function values(name) { return $$('input[name="' + name + '"]:checked', form).map(function (i) { return i.value; }); }
    // Le schede (snippets/mq-card, la stessa della collezione) arrivano da sections/mq-finder-cards con una richiesta sola,
    // partita alla prima scelta: nei dati della home restano solo id, età e categorie (28/10).
    var cards = null, run = 0;
    function loadCards() {
      return cards || (cards = fetch(data.cards).then(function (r) {
        if (!r.ok) throw new Error(r.status);
        return r.text();
      }).then(function (html) {
        var t = document.createElement('template'), map = {};
        t.innerHTML = html;
        $$('[data-id]', t.content).forEach(function (el) { map[el.getAttribute('data-id')] = el.outerHTML; });
        return map;
      }).catch(function (e) { cards = null; throw e; }));
    }
    form.addEventListener('change', function () { loadCards().catch(function () {}); }, { once: true });
    function results() {
      var age = values('age')[0], cats = values('cat'), seats = values('seats')[0] || 'any', price = values('price')[0] || 'any';
      var find = function (st, pr, anyCat) {
        return data.products.filter(function (p) {
          // stessa fascia del filtro «Età consigliata» («Non lo so ancora» = ogni età); senza età non si promette compatibilita'
          // posti: senza il dato il modello esce solo con «Non importa»; tetto di spesa: facoltativo (home «Dalla sede», 31/10)
          return (age === 'any' || p.band === age) && (anyCat || p.cats.some(function (c) { return cats.indexOf(c) > -1; })) &&
            (st === 'any' || p.seats === st) && (pr === 'any' || p.price <= +pr);
        }).sort(function (a, b) { return (b.available - a.available) || 0; });
      };
      // nessun modello con tutte le risposte: i più vicini, togliendo prima il tetto di spesa, poi i posti, poi il tipo
      // (l'età resta sempre); la frase generica solo se per quell'età non c'è niente (controllo finale, 31/10)
      var hits = find(seats, price), near = '';
      if (!hits.length && price !== 'any') { hits = find(seats, 'any'); near = 'price'; }
      if (!hits.length && seats !== 'any') { hits = find('any', 'any'); near = price !== 'any' ? 'seats' : 'seats_only'; }
      if (!hits.length) { hits = find('any', 'any', true); near = 'cat'; }
      if (!hits.length) near = '';
      var cntEl = $('[data-mq-finder-count]', out);
      cntEl.textContent = near ? (hits.length === 1 ? cntEl.getAttribute('data-near-one') : cntEl.getAttribute('data-near-n').replace('#N#', hits.length))
        : (hits.length === 1 ? S.oneMatch : S.matches.replace('{n}', hits.length));
      $('[data-mq-finder-none]', out).hidden = hits.length > 0;
      $$('[data-mq-finder-near]', out).forEach(function (n) { n.hidden = n.getAttribute('data-mq-finder-near') !== near; });
      var rail = $('[data-mq-finder-rail]', out), mine = ++run;
      rail.innerHTML = '';
      rail.hidden = hits.length === 0;
      if (hits.length) {
        rail.setAttribute('aria-busy', 'true');
        loadCards().then(function (map) {
          if (mine === run) rail.innerHTML = hits.map(function (p) { return map[p.id] || ''; }).join('');
        }, function () {
          // senza schede restano il conteggio e «Vedi tutti»
          if (mine !== run || at !== steps.length - 1) return;
          rail.hidden = true; err.textContent = S.finderError; err.hidden = false;
        }).then(function () { rail.removeAttribute('aria-busy'); });
      }
      var link = $('[data-mq-finder-all]', form), one = cats.length === 1 && near !== 'cat' ? data.collections[cats[0]] : null;
      var af = data.ageFilter, base = one || data.collections.all;
      link.href = age === 'any' ? base : base + (base.indexOf('?') > -1 ? '&' : '?') + af.param + '=' + encodeURIComponent(af[age]);
      link.hidden = false; // anche senza risultati: «Vedi tutti i modelli» resta
      var cnt = $('[data-mq-finder-count]', out); setTimeout(function () { cnt.focus({ preventScroll: true }); }, 0);
      out.setAttribute('aria-live', 'polite');
    }
    form.addEventListener('click', function (e) {
      var b = e.target.closest('[data-go]');
      if (!b) return;
      e.preventDefault();
      var dir = b.getAttribute('data-go');
      if (dir === 'restart') return show(0);
      if (dir === 'back') return show(Math.max(0, at - 1));
      var name = steps[at].getAttribute('data-step');
      if (name !== 'price' && !values(name).length) { err.textContent = S['finderNeed_' + name]; err.hidden = false; return; }
      if (at + 1 === steps.length - 1) results();
      show(at + 1);
    });
    show(0);
  });

  /* ---------- Barra in alto e linguetta: il −10% nella scheda porta al riquadro, altrove apre la finestra della linguetta
     (modulo incorporato di Klaviyo, o il codice di chi è già iscritto); sul telefono i messaggi della barra scorrono da soli ---------- */
  document.addEventListener('click', function (e) {
    var k = e.target.closest('[data-mq-klaviyo]');
    if (!k) return;
    var box = $('[data-mq-signup]');
    if (box) { // nella scheda il popup non compare (Klaviyo esclude /products/, Fabrizio 27/10): il −10% è il riquadro
      e.preventDefault();
      mqNoPopup = true; // l'invito −10% qui è il riquadro: il popup di Klaviyo non si somma
      box.scrollIntoView({ block: 'center', behavior: reduce ? 'auto' : 'smooth' });
      box.focus({ preventScroll: true });
      mqBack = box; // se il popup di Klaviyo si apre e si richiude, il fuoco torna qui (controllo-finale, 27/10)
      return;
    }
    var dlg = $('#mq-gift-dialog');
    if (dlg && dlg.showModal) { // si apre sempre: il popup di Klaviyo, una volta chiuso, nella stessa pagina non si riapre (27/10)
      e.preventDefault();
      mqNoPopup = true; // l'invito −10% qui è la nostra finestra: il popup di Klaviyo non si somma
      dlg.showModal();
      return;
    }
    if (!window.klaviyo) return; // senza Klaviyo vale il link all'iscrizione in home
    // openForm apre il popup anche dove le regole di Klaviyo lo escludono (doc Klaviyo, «custom trigger»): serve alle schede senza riquadro
    e.preventDefault();
    mqNoPopup = false; // qui il popup lo chiede chi tocca il −10% (anche dopo «Aggiungi al carrello»): resta aperto
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', k.getAttribute('data-mq-klaviyo')]);
  });
  // Linguetta −10%: si fa da parte mentre i bottoni dell'hero passano sul fondo dello schermo (Figma 17/09: mai sopra i bottoni).
  var gift = $('.mq-gift'), ctas = $('.mq-hero__ctas');
  if (gift && ctas && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (en) { gift.classList.toggle('is-away', en[0].isIntersecting); }, { rootMargin: '-88% 0px 0px 0px' }).observe(ctas);
  }
  // Sul telefono, finché si vede l'apertura della home o la testata delle Offerte, linguetta −10% e bollino WhatsApp (.mq-wa)
  // si fanno da parte: coprivano il pulsante rosso e i titoli (controllo finale, 30/10). La regola è in mq.css: nascoste da subito, tornano con body.mq-top-out (niente lampo prima che parta questo file).
  var tops = $$('.mq-hero, .mq-offer--page');
  if (tops.length && 'IntersectionObserver' in window) {
    var seen = new Set();
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (x) { if (x.isIntersecting) seen.add(x.target); else seen.delete(x.target); });
      document.body.classList.toggle('mq-top-out', seen.size === 0);
    });
    tops.forEach(function (t) { io.observe(t); });
  }
  // Riquadro della scheda e finestra della linguetta: il modulo incorporato di Klaviyo (fatto nell'editor, V2yf7r) mostra
  // il codice unico a schermo, con o senza il sì ai cookie. Se Klaviyo non arriva resta il modulo del tema
  // (snippets/mq-signup-form) e il codice (coupon Benvenuto10) arriva con l'email di benvenuto. L'incorporato creato via
  // API (WUWF6e) non compariva mai (27/10).
  // A chi si è già iscritto da questo browser si mostra il suo codice (mq_code), o dove trovarlo.
  var getCode = function () { try { return localStorage.getItem('mq_code') || ''; } catch (x) { return ''; } };
  var showDone = function (w) {
    var c = getCode();
    $('[data-mq-signup-invite]', w).hidden = true;
    $('[data-mq-signup-done]', w).hidden = false;
    $('[data-mq-code-row]', w).hidden = !c;
    $('[data-mq-code-none]', w).hidden = !!c;
    $('[data-mq-code]', w).textContent = c;
  };
  var signups = $$('[data-mq-signup], [data-mq-signup-dialog]');
  signups.forEach(function (w) {
    var copy = $('[data-mq-code-copy]', w);
    if (copy && window.rdCopyCode) copy.addEventListener('click', function () { window.rdCopyCode(getCode(), copy); });
    if (window.rdIsSubscribed && window.rdIsSubscribed()) showDone(w);
    // Modulo del tema: stessa lista del popup, con l'API pubblica di Klaviyo (risponde 202). Il codice non compare: quello
    // unico arriva con l'email di benvenuto (provato il 27/10, 11 secondi), quindi qui niente mq_code.
    var kl = $('.mq-signup__kl', w), fb = $('[data-mq-fb]', w);
    if (!kl || !fb) return;
    var err = $('[data-mq-fb-error]', fb), btn = $('button', fb);
    // Se il modulo incorporato di Klaviyo compare, prende il posto di quello del tema; chi sta già scrivendo finisce qui.
    var swap = function () {
      if (!kl.children.length) return;
      if (fb.contains(document.activeElement) || fb.email.value) w.classList.add('kl-late');
      else w.classList.remove('is-fb');
    };
    new MutationObserver(swap).observe(kl, { childList: true });
    swap(); // Klaviyo può aver già disegnato prima di questo file: senza, nella finestra si vedevano i due moduli (27/10)
    fb.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = fb.email.value.trim();
      err.hidden = true;
      fb.email.removeAttribute('aria-invalid');
      if (!email || !fb.email.checkValidity()) { err.textContent = fb.getAttribute('data-msg-invalid'); err.hidden = false; fb.email.setAttribute('aria-invalid', 'true'); fb.email.focus(); return; }
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
      fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + fb.getAttribute('data-company'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/vnd.api+json', revision: '2026-10-15' },
        body: JSON.stringify({ data: { type: 'subscription', attributes: { custom_source: fb.getAttribute('data-source'),
          profile: { data: { type: 'profile', attributes: { email: email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } } },
          relationships: { list: { data: { type: 'list', id: fb.getAttribute('data-list') } } } } })
      }).then(function (r) {
        if (!r.ok) throw r;
        if (window.rdMarkSubscribed) window.rdMarkSubscribed();
        showDone(w);
        $('[data-mq-signup-done]', w).focus();
      }).catch(function () {
        err.textContent = fb.getAttribute('data-msg-error'); err.hidden = false;
        btn.disabled = false; btn.removeAttribute('aria-busy');
        fb.email.focus(); // il pulsante disattivato ha perso il fuoco: si riparte dal campo
      });
    });
  });
  // Nella scheda si aspetta il modulo di Klaviyo, che compare anche senza il sì ai cookie (visitatore nuovo, 27/10); se in
  // 8 secondi non arriva (script bloccato), compare il modulo del tema. La finestra della linguetta parte dal modulo del
  // tema (is-fb nel Liquid): chiusa, Klaviyo non è detto che ci disegni dentro.
  setTimeout(function () {
    $$('[data-mq-signup]').forEach(function (w) { var kl = $('.mq-signup__kl', w); if (kl && !kl.children.length) w.classList.add('is-fb'); });
  }, 8000);
  // Una finestra alla volta (controllo-finale, 27/10). Klaviyo apre il suo popup al primo tocco su un link dopo i 5 secondi,
  // anche sulla linguetta, sul −10% della barra e su «Aggiungi al carrello», che aprono già una nostra finestra o portano al
  // riquadro. Dopo quei tocchi, con una nostra finestra aperta e nelle pagine con il riquadro, il popup si richiude subito con
  // la sua X: per Klaviyo è chiuso e per un giorno non torna. L'incorporato (V2yf7r) manda «embedOpen», non «open».
  var mqNoPopup = false, mqBack = null;
  window.addEventListener('klaviyoForms', function (e) {
    var d = e.detail || {};
    if (d.type === 'close' && mqBack) { // chiuso il popup, Klaviyo lascia il fuoco sulla pagina: torna al riquadro
      var b = mqBack; mqBack = null;
      setTimeout(function () { if (document.activeElement === document.body) b.focus({ preventScroll: true }); }, 400);
      return;
    }
    if (d.type !== 'open' || !(mqNoPopup || $('dialog[open]') || $('[data-mq-signup]'))) return;
    var tries = 0, t = setInterval(function () {
      var x = $('.klaviyo-close-form');
      if (x) x.click();
      if (x || ++tries > 40) clearInterval(t);
    }, 50);
  });
  // Chi si iscrive dal popup −10% o dal modulo incorporato («submit» parte quando lascia l'email) viene ricordato, e il suo
  // codice si legge appena Klaviyo lo mostra (prefisso MQ10-; MOTIQUE10 se i codici unici sono finiti). Il modulo che ha
  // ricevuto l'email tiene il suo messaggio di Klaviyo; gli altri riquadri della pagina passano al codice.
  window.addEventListener('klaviyoForms', function (e) {
    var d = e.detail || {}, id = d.formId || d.formID;
    if (d.type !== 'submit' || !id || (id !== window.mqPopupId && id !== window.mqEmbedId)) return;
    if (window.rdMarkSubscribed) window.rdMarkSubscribed();
    signups.forEach(function (w) { w.classList.add('is-sent'); });
    var tries = 0, t = setInterval(function () {
      var m = $$('[class*="klaviyo-form"]').map(function (n) { return n.innerText; }).join(' ').match(/MQ10-[A-Z0-9]{8}|MOTIQUE10/);
      if (m) {
        try { localStorage.setItem('mq_code', m[0]); } catch (x) {}
        signups.forEach(function (w) { var kl = $('.mq-signup__kl', w); if (!kl || kl.innerText.indexOf(m[0]) < 0) showDone(w); });
      }
      if (m || ++tries > 20) clearInterval(t);
    }, 500);
  });

  /* ---------- Video di TikTok (home «Dalla sede», 31/10): lettore ufficiale, solo dopo il sì ai cookie di marketing o al tocco ----------
     Prima c'è il riquadro «Il video si apre da TikTok»: nessuna richiesta a tiktok.com. Senza l'API del consenso vale «no».
     Gli ID restano testo (19 cifre: come numero JavaScript perderebbero le ultime). Niente autoplay: il video parte solo col tocco
     dentro il lettore di TikTok, così in home si muove da solo solo il video di apertura. */
  var ttUrl = 'https://www.tiktok.com/@motique.it/video/';
  function ttPlayer(box, tap) {
    var id = box.getAttribute('data-mq-tt');
    if (!/^\d+$/.test(id) || box.querySelector('iframe')) return null;
    var f = document.createElement('iframe');
    // dopo un tocco il video parte subito (basta un tocco); col solo consenso resta fermo
    f.src = 'https://www.tiktok.com/player/v1/' + id + '?description=0&music_info=0&rel=0' + (tap ? '&autoplay=1' : '');
    f.title = box.getAttribute('data-title');
    f.setAttribute('loading', 'lazy');
    f.setAttribute('allow', 'encrypted-media; fullscreen; picture-in-picture');
    f.setAttribute('allowfullscreen', '');
    box.appendChild(f);
    box.classList.add('is-on');
    return f;
  }
  function ttReset(box) { var f = box.querySelector('iframe'); if (f) f.remove(); box.classList.remove('is-on'); }
  var ttOk = function () { var p = window.Shopify && window.Shopify.customerPrivacy; try { return !!(p && p.marketingAllowed && p.marketingAllowed()); } catch (x) { return false; } };
  // all: anche le card della fila (data-mq-tt-tap), che col solo consenso non si caricano: solo al tocco, una alla volta
  var ttInline = function (all) { return $$('[data-mq-tt]').filter(function (b) { return !b.closest('dialog') && (all === true || !b.hasAttribute('data-mq-tt-tap')); }); };
  if ($('[data-mq-tt]')) {
    document.addEventListener('click', function (e) {
      var go = e.target.closest('[data-mq-tt-go]');
      if (!go) return;
      e.preventDefault();
      var box = go.closest('[data-mq-tt]'), dlg = go.closest('dialog');
      if (!dlg) ttInline(true).forEach(function (b) { if (b !== box) ttReset(b); }); // un video alla volta: il tocco ferma gli altri
      var f = ttPlayer(box, true);
      // nella finestra il fuoco resta su «Chiudi»: dentro il lettore di TikTok Esc non arriva e la finestra non si chiuderebbe (collaudo D2)
      if (f) (dlg ? $('[data-mq-close]', dlg) : f).focus();
    });
    document.addEventListener('visitorConsentCollected', function (e) { if (e.detail && e.detail.marketingAllowed) ttInline().forEach(function (b) { ttPlayer(b, false); }); });
    if (window.Shopify && window.Shopify.loadFeatures) {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], function (err) { if (!err && ttOk()) ttInline().forEach(function (b) { ttPlayer(b, false); }); }); // forEach passerebbe l'indice come «tocco»: partirebbe da solo (collaudo D1)
    }
  }
  // Cerchi «Dalla sede»: il tocco apre la finestra (openDialog, sopra: Esc chiude e il fuoco torna al cerchio) con quel video
  // e la scheda del modello; alla chiusura l'iframe si toglie, così l'audio di TikTok non continua dietro.
  document.addEventListener('click', function (e) {
    var st = e.target.closest('[data-mq-story]');
    if (st) {
      var d = document.getElementById(st.getAttribute('data-mq-open'));
      if (!d) return;
      var box = $('[data-mq-tt]', d), card = $('[data-mq-player-card]', d), img = $('img', card), id = st.getAttribute('data-mq-story');
      ttReset(box);
      box.setAttribute('data-mq-tt', id);
      $('[data-mq-tt-go]', box).href = ttUrl + id;
      card.href = st.getAttribute('data-url');
      $('[data-mq-player-name]', card).textContent = st.getAttribute('data-name');
      img.hidden = !st.getAttribute('data-img');
      if (!img.hidden) img.src = st.getAttribute('data-img');
      // riquadro prima del lettore: nome del modello e fondo (copertina, o foto prodotto contenuta su bianco)
      $('[data-mq-tt-name]', box).textContent = st.getAttribute('data-name');
      $('[data-mq-tt-go]', box).setAttribute('aria-label', st.getAttribute('data-watch'));
      $('[data-mq-player-ai]', d).hidden = !st.hasAttribute('data-ai'); // nota AI solo per i video che la chiedono (Porsche, Fabrizio 31/10)
      var pos = $('[data-mq-tt-poster]', box), ps = st.getAttribute('data-poster');
      pos.hidden = !ps;
      if (ps) { pos.src = ps; pos.classList.toggle('mq-tt__poster--product', st.getAttribute('data-poster-kind') === 'product'); }
      if (ttOk()) ttPlayer(box, true); // la finestra l'ha aperta un tocco
      return;
    }
    if (e.target.classList && e.target.classList.contains('mq-player')) e.target.close(); // tocco fuori dal lettore
  });
  document.addEventListener('close', function (e) {
    if (e.target.classList && e.target.classList.contains('mq-player')) ttReset($('[data-mq-tt]', e.target));
  }, true);

  /* ---------- Video prodotto («Un giro per modello.», banner di modello; 31/10): partono solo al tocco sul play, muti, uno alla volta.
     preload="none": prima del tocco si scarica solo la copertina. Anche con «movimento ridotto» parte solo se lo chiede chi tocca. ---------- */
  var vOf = function (b) { return b.parentElement.querySelector('video'); };
  $$('[data-mq-vplay]').forEach(function (b) {
    var v = vOf(b); if (!v) return;
    var set = function () { b.setAttribute('aria-pressed', String(!v.paused && !v.ended)); };
    v.addEventListener('play', set); v.addEventListener('pause', set); v.addEventListener('ended', set);
    b.addEventListener('click', function () {
      if (!v.paused) { v.pause(); return; }
      $$('[data-mq-vplay]').forEach(function (o) { var ov = vOf(o); if (ov && ov !== v && !ov.paused) ov.pause(); });
      var p = v.play(); if (p && p.catch) p.catch(function () {});
    });
  });

  /* ---------- «Sfoglia le categorie.» (home «Racconto», 31/10): etichette come tablist; le file sono già nella pagina, qui si mostra solo quella attiva.
     Frecce, Home e Fine spostano la scelta; con «movimento ridotto» il cambio non ha la dissolvenza (mq-home.css). ---------- */
  $$('[data-mq-cats]').forEach(function (root) {
    var tabs = $$('[role="tab"]', root);
    var pick = function (t, focus) {
      tabs.forEach(function (x) {
        var on = x === t;
        x.setAttribute('aria-selected', String(on));
        x.tabIndex = on ? 0 : -1;
        document.getElementById(x.getAttribute('aria-controls')).hidden = !on;
      });
      if (focus) t.focus();
    };
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { pick(t, false); });
      t.addEventListener('keydown', function (e) {
        var j = { ArrowRight: i + 1, ArrowDown: i + 1, ArrowLeft: i - 1, ArrowUp: i - 1, Home: 0, End: tabs.length - 1 }[e.key];
        if (j === undefined) return;
        e.preventDefault();
        pick(tabs[(j + tabs.length) % tabs.length], true);
      });
    });
  });

})();
